/* eslint-disable no-self-compare */
/* eslint-disable @typescript-eslint/no-unused-vars */
/* eslint-disable react-hooks/exhaustive-deps */
import { useState, useEffect } from "react";
import { Modal as AntModal } from "antd"
import { tokenDecode } from "../../../utils/helper";
import ThemeMaker from "../../../components/thememaker";
import axios from "axios";
import { toast } from "react-toastify";
import { useLocation, useHistory } from "react-router-dom";
import './onIssue.module.css'
import moment from "moment"
import { config } from "../../../utils/config";
import "../../../index.css";
import Snackbar, { SnackbarOrigin } from '@mui/material/Snackbar';
const { baseNodeapiUrl } = config;


const OnIssues = () => {
    const decoded: any = tokenDecode();
    const { data } = decoded;
    const { permission: { igm } } = data;

    // state
    const [isModalVisible, setIsModalVisible] = useState(false);
    const [uploading, setUpLoading] = useState(false);
    const [productData, setProductData]: any = useState("");
    const [closeStatus, setCloseStatus]: any = useState(true);
    const [TicketID, setTicketID]: any = useState("");
    const [DataLoading, setDataLoading]: any = useState(false);
    interface State extends SnackbarOrigin {
        open: boolean;
    }
    const [state, setState] = useState<State>({
        open: false,
        vertical: 'top',
        horizontal: 'center',
    });
    const { vertical, horizontal, open } = state;

    const [actionTakenData, setactionTakenData]: any = useState({
        short_desc: "",
        long_desc: "",
        action_taken: "",
        refund_amount: "",
        type: "",
        gro_type: "",
        remarks: "",
        gro_name: "",
        gro_email: "",
        gro_contact: "",
        cascaded_level: ""
    })

    const [showChat, setshowchat]: any = useState(false)
    const [chatArray, setChatArray]: any = useState([])

    let history = useHistory();
    const location = useLocation();
    if (location?.state) {
        var { tkt }: any = location?.state;
    } else {
        history.push("/issues");
    }

    const inputHandler = (e: any) => {
        e.preventDefault();
        setProductData({ ...productData, [e.target.name]: e.target.value });
    };
    const showModal = () => {
        setIsModalVisible(true);
    };
    const handleOk = () => {
        setIsModalVisible(false);
    };

    const handleCancel = () => {
        setIsModalVisible(false);
    };

    function actionChangeHandler(e: any) {
        setactionTakenData((prev: any) => {
            return { ...prev, [e.target.name]: e.target.value }
        })
    }

    const OnIssues_status = async (tkt: any) => {
        setDataLoading(true);
        try {
            const requestOptions = {
                method: "GET",
                headers: {
                    Authorization: `Bearer ${sessionStorage.getItem("token")}`,
                    "Content-Type": "application/json",
                },
            };
            const response = await fetch(
                `${baseNodeapiUrl}/digidukaan/snp/igm/getById/${tkt}`,
                requestOptions
            );
            if (!response.ok) {
                throw new Error("Failed to get ticket details");
            }
            const data = await response.json();
            setTicketID(data?.data?.[0]);
            setactionTakenData((prev: any) => ({
                ...prev,
                refund_amount: data?.priceValue ?? "",
            }));
        } catch (error) {
            toast.error("Error in getting ticket details");
            console.error("error", error);
        } finally {
            setDataLoading(false);
        }
    };

    // ================== API CALL (unsolicited_on_issue_status) ==================
    const updateIssuesHanlder = async (e: any) => {
        e.preventDefault();

        if (!productData.status) {
            return toast.error("Please select a status");
        }

        let payLoad: any;

        if (productData.status === "NEED-MORE-INFO") {
            if (!actionTakenData.remarks?.trim()) return toast.error("Please enter Remarks");
            payLoad = {
                issue_id: TicketID?.issue_id,
                description: actionTakenData.remarks,
                respondent_action: productData.status,
            };
        } else {
            // RESOLVED / CASCADED
            if (!actionTakenData.short_desc?.trim()) return toast.error("Please enter Short Description");
            if (!actionTakenData.long_desc?.trim()) return toast.error("Please enter Long Description");
            if (actionTakenData.action_taken === "REFUND" && !String(actionTakenData.refund_amount).trim()) {
                return toast.error("Please enter Refund Amount");
            }

            payLoad = {
                issue_id: TicketID?.issue_id,
                provider_id: data?.seller_data?.[0]?.provider_id,
                respondent_action: productData.status,
                short_desc: actionTakenData.short_desc,
                long_desc: actionTakenData.long_desc,
                refund_amount: actionTakenData.action_taken === "REFUND" ? actionTakenData.refund_amount : "",
                action_triggered: actionTakenData.action_taken || "NO-ACTION",
            };
        }

        try {
            setUpLoading(true);
            await axios({
                url: `${baseNodeapiUrl}/digidukaan/snp/igm/unsolicited_on_issue_status`,
                method: "POST",
                headers: {
                    Authorization: `Bearer ${sessionStorage.getItem("token")}`,
                    "Content-Type": "application/json",
                },
                data: payLoad,
            });
            setUpLoading(false);
            toast.success("Issues Status updated successfully !", {
                position: "top-right",
                autoClose: 5000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
                progress: undefined,
            });
            OnIssues_status(tkt); // ticket refresh
        } catch (error) {
            setUpLoading(false);
            toast.error("404 error ! please reach to support@ens.enterprises", {
                position: "top-right",
                autoClose: 5000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
                progress: undefined,
            });
        }
    }
    // ============================================================================

    async function actionTakenforLspHandler(e: any) {
        const data = await axios({
            url: `${baseNodeapiUrl}/igm/issue_to_LSP`,
            method: "POST",
            headers: {
                Authorization: `Bearer ${sessionStorage.getItem("token")}`,
                "Content-Type": "application/json",
            },
            data: {
                "order_id": TicketID?.order_id,
                "issue_id": TicketID?.issue_id,
                "description": "Complaint is being CASCADED successfully.",
                "respondent_action": "CASCADED"
            }
        })
        if (data) {
            console.log("data------", data)
        }
    }

    async function showChatHandler() {
        const { data } = await axios({
            method: "GET",
            url: `${baseNodeapiUrl}/igm/chatDetails/${tkt}`,
        })

        if (data?.message == "success") {
            setChatArray([...data?.chat])
        }
        setshowchat(true)
    }

    useEffect(() => {
        OnIssues_status(tkt)
    }, []);

    return (
        <>
            <ThemeMaker>
                <form onSubmit={updateIssuesHanlder}>
                    <div className="pl-4 pr-4 mt-4">
                        <div className="row rounded-lg overflow-hidden shadow">
                            {/* <!-- Chat Box--> */}
                            <div className="messages col-md-8 col-sm-12 col-12 px-0" >
                                <div className="card-header d-flex justify-content-between">
                                    <h5 className="m-0 font-weight-bold text-primary">
                                        Ticket Responser
                                    </h5>
                                </div>

                                <div>
                                    <div className="row">
                                        <div className="col-md-12 pl-4 pr-4">

                                            <div className="row mt-2">
                                                <div className="col-md-4">
                                                    <div className="form-group">
                                                        <label className="genericlabel">Name</label>
                                                        <input
                                                            type="text"
                                                            className="form-control"
                                                            name="title"
                                                            placeholder="Name"
                                                            value={TicketID?.complainant_info?.person?.name}
                                                            readOnly
                                                        />
                                                    </div>
                                                </div>

                                                <div className="col-md-4">
                                                    <div className="form-group">
                                                        <label className="genericlabel">Email</label>
                                                        <input
                                                            type="text"
                                                            className="form-control"
                                                            name="compareprice"
                                                            placeholder="Enter email"
                                                            value={TicketID?.complainant_info?.contact?.email}
                                                            readOnly
                                                        />
                                                    </div>
                                                </div>
                                                <div className="col-md-4">
                                                    <div className="form-group">
                                                        <label className="genericlabel">Short description</label>
                                                        <input
                                                            type="text"
                                                            className="form-control"
                                                            name="netweight"
                                                            placeholder="Enter description 1"
                                                            value={TicketID?.description?.short_desc}
                                                            readOnly
                                                        />
                                                    </div>
                                                </div>
                                                <div className="col-md-8">
                                                    <div className="form-group">
                                                        <label className="genericlabel">Long description</label>
                                                        <input
                                                            type="text"
                                                            className="form-control"
                                                            name="netweight"
                                                            placeholder="Enter description 2"
                                                            value={TicketID?.description?.long_desc}
                                                            readOnly
                                                        />
                                                    </div>
                                                </div>

                                                <div className="col-md-4 d-flex align-items-center">
                                                    <div className="text-center d-flex">
                                                        {TicketID?.description?.images ? <span className="badge badge-primary" style={{ cursor: "pointer" }}> <a href={TicketID?.description?.images[0]} target="_blank" style={{ color: "white", cursor: "pointer" }}>Product Image</a> </span> : null}
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                {showChat && <div>
                                    <div className="px-4 py-5 h-75 chat-box bg-white" style={{ maxHeight: "400px", overflow: "scroll" }}>
                                        <h3 className="text-center mb-5">Complaint History</h3>
                                        {chatArray.map((message: any, index: any) => (
                                            <div className={`media w-50 ${message.key === 'buyer' ? '' : 'ml-auto'} mb-3`} key={index}>
                                                {message.key === 'buyer' && <img
                                                    src="https://bootstrapious.com/i/snippets/sn-chat/avatar.svg"
                                                    alt="user"
                                                    width="50"
                                                    className="rounded-circle"
                                                />}
                                                <div className="media-body ml-3">
                                                    {message.key === 'buyer' && <div className="bg-primary rounded py-2 px-3 mb-2" >
                                                        <p className={`text-small mb-0 ${message.key === 'buyer' ? 'text-white' : 'text-dark'}`}>
                                                            {message.long_desc}
                                                        </p>
                                                    </div>}

                                                    {message.key === 'buyer' ? <p className="small text-muted m-0 p-0">{message.short_desc}</p> : message?.short_desc && <p className="bg-primary rounded py-2 px-3 small text-light mb-0" >{message?.short_desc}</p>}

                                                    {message.key === 'buyer' ? <p className="small text-dark m-0 p-0">{moment(message.created_at).format("DD-MM-YYYY hh:mm:ss")}</p> : message?.updated_at && <p className="rounded small text-dark m-0 p-0" >{moment(message.updated_at).format("DD-MM-YYYY hh:mm:ss")}</p>}

                                                    {message?.refund_desc ? <p className="bg-primary rounded py-2 px-3 small text-light mb-0" >{message?.refund_desc}</p> : null}

                                                </div>
                                            </div>
                                        ))}

                                    </div>
                                </div>
                                }
                            </div>

                            {/* <!-- Status box--> */}
                            <div className=" col-md-4 col-sm-12 col-12 px-0 ">
                                <div className="card-header d-flex justify-content-between">
                                    <h5 className="m-0 font-weight-bold text-primary">
                                        Ticket Details
                                    </h5>
                                    <div className={`form-check`} id='StatusLight'>
                                        <input className={`form-check-input ${TicketID?.status}`} checked={TicketID?.status === TicketID?.status ? true : false} type="radio" name="flexRadioDefault" readOnly />
                                    </div>
                                </div>
                                <div className="card">
                                    <div className="card-body" style={{ height: "65vh", overflow: "scroll" }}>
                                        <div className="row" >
                                            <div className="col-md-12" >
                                                <label className="genericlabel">Order ID</label>
                                                <input
                                                    type="text"
                                                    className="form-control"
                                                    name="title"
                                                    placeholder="Enter Order Id"
                                                    value={TicketID?.order_details?.id}
                                                    readOnly
                                                />
                                            </div>
                                            <div className="col-md-12" >
                                                <label className="genericlabel">Ticket No</label>
                                                <input
                                                    type="text"
                                                    className="form-control"
                                                    name="title"
                                                    placeholder="Enter Ticket No"
                                                    value={TicketID?.issue_id}
                                                    readOnly
                                                />
                                            </div>
                                            <div className="col-md-12">
                                                <label className="genericlabel">Issues status</label>
                                                <select name="status" className="form-control"
                                                    onChange={(e) => { inputHandler(e); setCloseStatus(e.target.value) }}>
                                                    <option selected>Select Status</option>
                                                    {TicketID?.status === "RESOLVED" ? (
                                                        <option selected value="RESOLVED">Resolved</option>
                                                    ) : TicketID?.status === "CLOSED" ? (
                                                        <option selected value="CLOSED">Closed</option>
                                                    ) : TicketID?.status === "PROCESSING" ? (
                                                        <>
                                                            <option selected value="PROCESSING">Processing</option>
                                                            <option value="RESOLVED">Resolved</option>
                                                        </>
                                                    ) : (
                                                        <>
                                                            <option selected={TicketID?.status === "CLOSED" ? true : false} value="CLOSED">Closed</option>
                                                            <option selected={TicketID?.status === "RESOLVED" ? true : false} value="RESOLVED">Resolved</option>
                                                            <option selected={TicketID?.status === "PROCESSING" ? true : false} value="PROCESSING">Processing</option>
                                                            <option selected={TicketID?.status === "CASCADED" ? true : false} value="CASCADED">Cascaded</option>
                                                            <option selected={TicketID?.status === "NEED-MORE-INFO" ? true : false} value="NEED-MORE-INFO">Need more Information</option>
                                                            <option selected={TicketID?.status === "ESCALATE" ? true : false} value="ESCALATED">Escalate</option>
                                                        </>
                                                    )}
                                                </select>
                                            </div>

                                            {(productData.status == "RESOLVED" || productData.status == "CASCADED") && <div className="mt-2 py-1 px-3 d-flex flex-column col-md-12" style={{ gap: "10px" }}>
                                                <div>
                                                    <label htmlFor="" className="genericlabel">Short Description</label> <br />
                                                    <input type="text" className="form-control w-100" placeholder="Enter Short Desc" name="short_desc" value={actionTakenData.short_desc} onChange={(e: any) => actionChangeHandler(e)} />
                                                </div>
                                                <div>
                                                    <label htmlFor="" className="genericlabel">Long Description</label> <br />
                                                    <input type="text" className="form-control w-100" placeholder="Enter Long Desc" name="long_desc" value={actionTakenData.long_desc} onChange={(e: any) => actionChangeHandler(e)} />
                                                </div>
                                                <div>
                                                    <label className="genericlabel">Action Taken</label>
                                                    <select name="action_taken"
                                                        className="form-control"
                                                        value={actionTakenData.action_taken}
                                                        onChange={(e) => { actionChangeHandler(e) }} >
                                                        <option value="">Select Action Taken</option>
                                                        <option value="REFUND">Refund</option>
                                                        <option value="REPLACEMENT">Replacement</option>
                                                        <option value="CANCEL">Cancel</option>
                                                        <option value="NO-ACTION">No Action</option>
                                                    </select>

                                                    {actionTakenData?.action_taken == "REFUND" && <div className="mt-4 d-flex align-items-center">
                                                        <div className="form-group w-100">
                                                            <label htmlFor="" className="genericlabel">Refund Amount</label>
                                                            <input type="number" className="form-control" name="refund_amount" placeholder="Enter Refund Amount" value={actionTakenData.refund_amount} onChange={(e: any) => actionChangeHandler(e)} />
                                                        </div>
                                                    </div>}
                                                </div>

                                                {/* Submit button: click par API call */}
                                                <div className="mt-2">
                                                    <button
                                                        type="button"
                                                        className="btn btn-primary w-100"
                                                        disabled={uploading}
                                                        onClick={updateIssuesHanlder}
                                                    >
                                                        {uploading ? "Submitting..." : "Submit"}
                                                    </button>
                                                </div>
                                            </div>}


                                            {(productData.status == "NEED-MORE-INFO") && <div className="mt-2 py-1 px-3 d-flex flex-column col-md-12" style={{ gap: "10px" }}>
                                                <div >
                                                    <label>Remarks</label>
                                                    <input
                                                        type="text"
                                                        className="form-control"
                                                        name="remarks"
                                                        placeholder="Enter Remarks"
                                                        value={actionTakenData.remarks}
                                                        onChange={(e: any) => actionChangeHandler(e)}
                                                    />
                                                </div>
                                            </div>

                                            }

                                            {/* <div className="col-md-12">
                                                <label className="genericlabel">Category</label>
                                                <input type="text"
                                                    className="form-control"
                                                    name="category"
                                                    placeholder="Enter Category"
                                                    value={TicketID?.category}
                                                    readOnly
                                                />
                                            </div> */}
                                            {/* <div className="col-md-12">
                                                <label className="genericlabel">Sub Category</label>
                                                <input type="text"
                                                    className="form-control"
                                                    name="title"
                                                    placeholder="Enter Sub Category"
                                                    value={TicketID?.sub_category}
                                                    readOnly
                                                />
                                            </div> */}
                                        </div>
                                    </div>
                                    <div className="col-md-12 mb-2 d-flex flex-nowrap justify-content-between">
                                        {igm?.update && TicketID?.status?.toUpperCase() !== "RESOLVED" && TicketID?.status?.toUpperCase() !== "CLOSED" && (
                                            <button type="submit" className="btn btn-primary" disabled={uploading}>
                                                {uploading ? "Submitting..." : "Submit"}
                                            </button>
                                        )}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    {/* model */}
                    <AntModal
                        className={``}
                        open={isModalVisible}
                        onOk={handleOk}
                        onCancel={handleCancel}
                        width={1000}
                    >
                        <div className="row">
                            <div className="col-md-12 pl-4 pr-4">
                                <div className="card-header">
                                    <h5 className="m-0 font-weight-bold text-primary">Info</h5>
                                </div>
                                <div className="row">
                                    <div className="col-md-4">
                                        <div className="form-group">
                                            <label>Name</label>
                                            <input
                                                type="text"
                                                className="form-control"
                                                name="title"
                                                placeholder="Name"
                                                value={TicketID?.complainant_info?.person?.name}
                                                readOnly
                                            />
                                        </div>
                                    </div>

                                    <div className="col-md-4">
                                        <div className="form-group">
                                            <label>Email</label>
                                            <input
                                                type="text"
                                                className="form-control"
                                                name="compareprice"
                                                placeholder="Enter email"
                                                value={TicketID?.complainant_info?.contact?.email}
                                                readOnly
                                            />
                                        </div>
                                    </div>
                                    <div className="col-md-4">
                                        <div className="form-group">
                                            <label>Short description</label>
                                            <input
                                                type="text"
                                                className="form-control"
                                                name="netweight"
                                                placeholder="Enter description 1"
                                                value={TicketID?.description?.short_desc}
                                                readOnly
                                            />
                                        </div>
                                    </div>
                                    <div className="col-md-8">
                                        <div className="form-group">
                                            <label>Long description</label>
                                            <input
                                                type="text"
                                                className="form-control"
                                                name="netweight"
                                                placeholder="Enter description 2"
                                                value={TicketID?.description?.long_desc}
                                                readOnly
                                            />
                                        </div>
                                    </div>
                                    {TicketID?.description?.images ? <div className="col-md-4">
                                        <label>Product Image</label>
                                        <div className="text-center">
                                            <img src={TicketID?.description?.images[0]} alt="..." className="rounded" width={200} height={200} />
                                        </div>
                                    </div> : null}
                                </div>
                            </div>
                        </div>
                    </AntModal>
                </form>
                <Snackbar open={DataLoading} message="Loading..." key={vertical + horizontal} anchorOrigin={{ vertical, horizontal }} />
            </ThemeMaker >
        </>
    );
};
export default OnIssues;